// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function LeafletMap(Props) {
  var children = Props.children;
  var isTracerPresent = Props.isTracerPresent;
  var mapContainerClassName = "order-details-map__container order-details-map__canvas " + (
    isTracerPresent.contents ? "map-with-tracker" : ""
  );
  return React.createElement("div", {
              className: mapContainerClassName
            }, children);
}

var make = LeafletMap;

export {
  make ,
  
}
/* react Not a pure module */
